<template>
  <div>
    <div class="navbar-box">
      <div class="d-flex a-center js-between navbar-wrap">
        <div class="d-flex a-center">
          <img src="@/assets/static/img/logo_dark.png" class="icon-logo" alt="">
          <span style="font-size:12px;">v{{app_version}}</span>
        </div>
        <div class="flex-1 d-flex a-center js-end">
          <div class="d-flex a-center cursor-pointer">
            <img :src="avatar" class="icon-avatar" alt="">
            <el-dropdown trigger="click" @command="clickHandle">
              <span class="el-dropdown-link">
                {{nickname}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="edit"><div class="d-flex a-center"><img src="@/assets/static/img/setting.png" class="dropdown-icon" />修改资料</div></el-dropdown-item>
                <el-dropdown-item v-permission="['*', 'client.cir-circle-pay-log.list']" command="income"><div class="d-flex a-center"><img src="@/assets/static/img/shoufei.png" class="dropdown-icon" />收入明细</div></el-dropdown-item>
                <el-dropdown-item command="exit"><div class="d-flex a-center"><img src="@/assets/static/img/exit.png" class="dropdown-icon" />退出</div></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 48px"></div>
<!--    测评二维码-->
    <div v-if="showRiskCode" class="risk-code-wrap">
      <div class="risk-code-box">
        <div class="risk-code" ref="riskCodeRef" id="riskCode" style="width: 200px;height: 200px;margin: 0 auto"></div>
        <div class="tips-text">请使用手机扫描二维码完成测评后刷新页面查看</div>
      </div>
    </div>
  </div>
</template>

<script>

import {clearStorage, setStorage} from "@/utils/auth";
import store from "@/store";
import QRCode from "qrcodejs2";

export default {
  name: 'NavbarIndex',
  data() {
    return {
      imgUrl: process.env['VUE_APP_CDN_HOST'],
      app_version: process.env['VUE_APP_VERSION'],
      avatar: '',
      nickname: '',
      showRiskCode: false
    }
  },
  mounted() {
    // 模拟获取用户信息
    this.$EventBus.$on('updateBaseInfo', () => {
      this.getInfo()
    })
    this.getInfo()
  },
  beforeDestroy() {
    this.$EventBus.$off('updateBaseInfo')
  },
  methods: {
    getInfo() {
      this.$axios.post('admin/login/info', {}).then(res => {
        if (res.code == 0) {

          this.avatar =  res.data.info.avatar && res.data.info.avatar.indexOf('ttp')==-1?this.imgUrl+res.data.info.avatar:res.data.info.avatar
          this.nickname =  res.data.info.nickname

          setStorage('pc_voice_remind', res.data.info.pc_voice_remind)
          setStorage('u_code', res.data.info.u_code)
          setStorage('nickname', res.data.info.nickname)
          setStorage('mobile', res.data.info.mobile)
          setStorage('avatar', res.data.info.avatar)
          setStorage('now_circle_code', res.data.info.now_circle_code)
          setStorage('circle_name', res.data.info.circle_name)
          setStorage('user_type', res.data.info.user_type)
          setStorage('im_sign', res.data.info.im_sign)
          localStorage.setItem('rights', JSON.stringify(res.data.rights))
          localStorage.setItem('certificate_no', res.data.info.certificate_no)
          localStorage.setItem('teacher_name', res.data.info.teacher_name)

          // 已购买但是未评测用户强制评测
          if (res.data.info.now_circle_code && res.data.info.user_type == 'user' && res.data.info.risk_estimate_result=='') {
            this.showRiskQrCode()
          }
        } else {
          this.$notify.warning(res.message || '网络错误')
        }
      })
    },
    showRiskQrCode() {
      this.showRiskCode = true
      this.$nextTick(() => {
        this.$refs.riskCodeRef.innerHTML = ''
        new QRCode(this.$refs.riskCodeRef, {
          text: process.env['VUE_APP_HOST'] + '/pages/mine/index?toRisk=1', // 表示内容，可以是地址或者是文字'55566'或者参数
          width: 200,
          height: 200,
          colorDark: '#000000', // 前景色
          colorLight: '#ffffff', // 背景色
          correctLevel: QRCode.CorrectLevel.H // 容错级别
        })
      })
    },
    clickHandle(command) {
      console.log("command",command)
      if (command === 'exit') {
        this.$EventBus.$emit('exitIM')
        clearStorage()
        localStorage.clear()
        store.dispatch('user/resetToken')
        this.$router.push({path: '/login'})
      } else if (command == 'edit') {
        this.$router.push({path: '/infoEdit'})
      } else if (command == 'income') {
        this.$router.push({path: '/incomeDetails'})
      }
    }
  }
}
</script>

<style scoped>
.navbar-box{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  background-color: #FFFFFF;
  z-index: 99;
}
.navbar-wrap{
  width: 900px;
  margin: 0 auto;
  height: 48px;
  line-height: 48px;
}
.icon-logo{
  width: 104px;
  height: 36px;
  margin-right: 12px;
}
.logo-txt{
  font-weight: bold;
  color: #000;
  font-size: 21px;
}
.icon-avatar{
  width: 20px;
  height: 20px;
  border-radius: 100%;
  margin-right: 5px;
}
.name-txt{
  font-size: 16px;
  color: #000;
}
.dropdown-icon{width:16px;height: 16px;margin-right: 4px;}
.risk-code-wrap{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4);
}
.risk-code-box{
  background-color: #fff;
  padding: 20px;
  border-radius: 20px;
}
.risk-code-box .tips-text{
  margin-top: 20px;color: #666;font-size: 14px;text-align: center
}
</style>
